import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Icon cards',
    defaultMessage: 'Icon cards',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
  items: {
    id: 'Cards',
    defaultMessage: 'Cards',
  },
  item: {
    id: 'Card',
    defaultMessage: 'Card',
  },
  icon: {
    id: 'Icon',
    defaultMessage: 'Icon',
  },
  color: {
    id: 'Color',
    defaultMessage: 'Color',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  iconCoral: {
    id: 'Coral',
    defaultMessage: 'Coral',
  },
  iconFlower: {
    id: 'Flower',
    defaultMessage: 'Flower',
  },
  iconShell: {
    id: 'Shell',
    defaultMessage: 'Shell',
  },
  iconStarfish: {
    id: 'Starfish',
    defaultMessage: 'Starfish',
  },
  colorPurple: {
    id: 'Purple',
    defaultMessage: 'Purple',
  },
  colorGray: {
    id: 'Gray',
    defaultMessage: 'Gray',
  },
  colorTan: {
    id: 'Tan',
    defaultMessage: 'Tan',
  },
  colorPlum: {
    id: 'Plum',
    defaultMessage: 'Plum',
  },
});

export const IconCardItemSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.item),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['icon', 'color', 'text'],
    },
  ],
  properties: {
    icon: {
      title: intl.formatMessage(messages.icon),
      type: 'string',
      choices: [
        ['coral', intl.formatMessage(messages.iconCoral)],
        ['flower', intl.formatMessage(messages.iconFlower)],
        ['shell', intl.formatMessage(messages.iconShell)],
        ['starfish', intl.formatMessage(messages.iconStarfish)],
      ],
      default: 'coral',
    },
    color: {
      title: intl.formatMessage(messages.color),
      type: 'string',
      choices: [
        ['purple', intl.formatMessage(messages.colorPurple)],
        ['gray', intl.formatMessage(messages.colorGray)],
        ['tan', intl.formatMessage(messages.colorTan)],
        ['plum', intl.formatMessage(messages.colorPlum)],
      ],
      default: 'purple',
    },
    text: {
      title: intl.formatMessage(messages.text),
      type: 'string',
      widget: 'textarea',
    },
  },
  required: [],
});

/**
 * Schema do bloco Icon Cards.
 * Vocabulário de ícones é FECHADO (SVGs do tema, sem upload) e cores são
 * choices de token — ver docs/specs/schema-decisions.md §3.
 */
const IconCardsSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['heading', 'items'],
    },
  ],
  properties: {
    heading: {
      title: intl.formatMessage(messages.heading),
      type: 'string',
    },
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: IconCardItemSchema({ intl }),
    },
  },
  required: [],
});

export default IconCardsSchema;
